export class SpeakInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get speak() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    get isSystemCurrentlySpeaking() {
        return this.app.mediaPlayer.playerChannels.channelVoice.channelInfo.isChannelCurrentlyPlaying;
    }
}
